var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeMedal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#c04d55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m309.02 118.169h41.344v15h-41.344z",
    transform: "matrix(.139 -.99 .99 .139 159.48 434.727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.952 104.982h15v44.281h-15z",
    transform: "matrix(.99 -.139 .139 .99 -15.878 26.554)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m448.27 319.82c0 53.01-21.58 101.07-56.43 135.87-34.82 34.78-82.87 56.31-135.87 56.31-3.69 0-7.35-.1-10.99-.31-48.63-2.75-92.48-23.64-124.88-56-34.85-34.8-56.43-82.86-56.43-135.87 0-52.98 21.57-101.02 56.39-135.82 32.4-32.38 76.26-53.29 124.92-56.04 3.64-.21 7.3-.31 10.99-.31 53.02 0 101.09 21.55 135.91 56.35s56.39 82.84 56.39 135.82z",
    fill: "#fb963f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.88 184-11.37 11.37-124.49 124.5-.05.04-135.91-135.91c32.4-32.38 76.26-53.29 124.92-56.04 3.64-.21 7.3-.31 10.99-.31 53.02 0 101.09 21.55 135.91 56.35z",
    fill: "#f66c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.84 455.69c-34.82 34.78-82.87 56.31-135.87 56.31-3.69 0-7.35-.1-10.99-.31-48.63-2.75-92.48-23.64-124.88-56l135.83-135.82.04-.05z",
    fill: "#f66c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.27 319.82c0 53.01-21.58 101.07-56.43 135.87-34.82 34.78-82.87 56.31-135.87 56.31-3.69 0-7.35-.1-10.99-.31 101.08-5.7 181.29-89.42 181.29-191.87 0-102.44-80.21-186.16-181.29-191.86 3.64-.21 7.3-.31 10.99-.31 53.02 0 101.09 21.55 135.91 56.35s56.39 82.84 56.39 135.82z",
    fill: "#f66c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.47 444.32 11.37 11.37c-34.82 34.78-82.87 56.31-135.87 56.31-3.69 0-7.35-.1-10.99-.31 54.22-3.06 102.43-28.57 135.49-67.37z",
    fill: "#de4f42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.98 127.96c3.64-.21 7.3-.31 10.99-.31 53.02 0 101.09 21.55 135.91 56.35l-11.37 11.37c-33.06-38.83-81.29-64.35-135.53-67.41z",
    fill: "#de4f42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.4 8.19-79.43 97.01h-160l84.64-103.36c.95-1.17 2.37-1.84 3.88-1.84h147.04c4.23 0 6.55 4.92 3.87 8.19z",
    fill: "#f55c80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.4 8.19-79.43 97.01h-30.13l85.97-105.2h19.72c4.23 0 6.55 4.92 3.87 8.19z",
    fill: "#cc5466"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fdb8b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.81 0-86.15 105.2h-19.38l86.13-105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.81 0-86.15 105.2h-19.39l86.15-105.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m402.85 319.82c0 81.07-65.76 146.78-146.88 146.78-3.36 0-6.7-.11-10-.34-76.46-5.13-136.88-68.73-136.88-146.44 0-77.7 60.42-141.31 136.88-146.44 3.3-.23 6.64-.34 10-.34 81.12 0 146.88 65.72 146.88 146.78z",
    fill: "#de4f42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.85 319.82c0 81.07-65.76 146.78-146.88 146.78-3.36 0-6.7-.11-10-.34 76.46-5.13 136.88-68.73 136.88-146.44 0-77.7-60.42-141.31-136.88-146.44 3.3-.23 6.64-.34 10-.34 81.12 0 146.88 65.72 146.88 146.78z",
    fill: "#c04d55"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fb963f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m200.97 250.122c-8.284 0-15 6.712-15 14.99v109.423c0 8.279 6.716 14.99 15 14.99s15-6.712 15-14.99v-109.423c0-8.278-6.716-14.99-15-14.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.97 250.122c-8.284 0-15 6.712-15 14.99v109.423c0 8.279 6.716 14.99 15 14.99s15-6.712 15-14.99v-109.423c0-8.278-6.716-14.99-15-14.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.97 250.122c-8.284 0-15 6.712-15 14.99v109.423c0 8.279 6.716 14.99 15 14.99s15-6.712 15-14.99v-109.423c0-8.278-6.716-14.99-15-14.99z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m300.97 105.2h-160l-22.66-27.67-56.7-69.24c-2.71-3.32-.35-8.29 3.93-8.29h146.7c1.64 0 3.19.73 4.23 2z",
    fill: "#f55c80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.97 105.2h-160l-22.66-27.67h88.42c17.02 0 26.38-19.78 15.6-32.95l-36.51-44.58h26.42c1.64 0 3.19.73 4.23 2z",
    fill: "#cc5466"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fdb8b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m190.67 105.2h-19.39l-22.66-27.67-63.48-77.53h19.38l63.49 77.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.98 105.2h-19.4l-29.5-36.03-56.64-69.17h19.38l36.51 44.58z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fb9e9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.01 77.53 22.66 27.67h-19.39l-22.66-27.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.98 105.2h-19.4l-29.5-36.03c4.97-6.94 5.55-16.89-.75-24.59z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f66c4c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m331.276 217.738c-3.334-2.459-8.029-1.752-10.488 1.581s-1.751 8.029 1.581 10.488c9.255 6.83 17.38 15.009 24.152 24.312 1.468 2.017 3.753 3.087 6.07 3.087 1.53 0 3.075-.467 4.407-1.437 3.349-2.438 4.088-7.129 1.65-10.478-7.674-10.542-16.883-19.812-27.372-27.553z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.137 216.665c-11.098 7.947-20.803 17.579-28.846 28.627-2.438 3.349-1.699 8.04 1.65 10.478 1.332.97 2.876 1.437 4.407 1.437 2.317 0 4.602-1.07 6.07-3.087 7.097-9.75 15.66-18.248 25.452-25.26 3.368-2.411 4.143-7.096 1.731-10.464-2.41-3.368-7.095-4.144-10.464-1.731z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.998 383.87c-3.35-2.438-8.04-1.698-10.478 1.65-6.771 9.303-14.897 17.482-24.152 24.312-3.333 2.459-4.041 7.155-1.581 10.488 1.471 1.993 3.74 3.047 6.041 3.047 1.547 0 3.107-.477 4.448-1.466 10.489-7.74 19.698-17.011 27.373-27.554 2.437-3.348 1.698-8.039-1.651-10.477z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.871 410.78c-9.792-7.012-18.355-15.51-25.452-25.26-2.437-3.347-7.127-4.089-10.477-1.649-3.349 2.438-4.088 7.128-1.65 10.477 8.042 11.049 17.748 20.681 28.846 28.628 1.323.947 2.849 1.403 4.36 1.403 2.337 0 4.64-1.089 6.104-3.134 2.411-3.369 1.636-8.054-1.731-10.465z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.97,
    cy: 200.497,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 207.693,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.81,
    cy: 207.692,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.97,
    cy: 439.143,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.13,
    cy: 431.947,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.81,
    cy: 431.948,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.37,
    cy: 319.823,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.174,
    cy: 278.983,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.175,
    cy: 360.663,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.724,
    cy: 319.823,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.92,
    cy: 278.983,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.919,
    cy: 360.663,
    r: 7.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m390.97 97.697h-270c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h270c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z",
    fill: "#fb963f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronze-medal.f81006675f0de676dd0ca64978c54d67.svg";
export { ForwardRef as ReactComponent };